import axios from 'axios';
import moment from 'moment';
import 'moment/locale/fr';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Card from 'react-bootstrap/Card';
import CardHeader from 'react-bootstrap/CardHeader';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import { FaPlus, FaRegPenToSquare, FaRegTrashCan } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { IExpense, ILine } from '../../../../../types';
import LineModal from '../../Modals/Lines/Lines';

import { IconWrapper } from '../../../../IconWrapper/IconWrapper';
import styles from './Lines.module.scss';

interface ILinesProps {
  expense: IExpense;
  onChange: () => void;
}

const Lines = ({ expense, onChange }: ILinesProps) => {
  const [showAddLine, setShowAddLine] = useState<boolean>(false);
  const [modalLine, setModalLine] = useState<ILine | undefined>(undefined);

  const handleNewLine = () => {
    setModalLine(undefined);
    setShowAddLine(true);
  };

  const handleEditLine = (line: ILine) => () => {
    setModalLine(line);
    setShowAddLine(true);
  };

  const handleCloseAddLine = () => {
    setShowAddLine(false);
    onChange();
  };

  const handleDelete = (id: string) => () => {
    axios
      .delete(`/api/expense/${expense._id}/line/${id}`)
      .then(() => {
        onChange();
      })
      .catch((err) => toast.error(err.response.data.message));
  };

  return (
    <>
      <Card>
        <CardHeader className="d-flex justify-content-between">
          <Col>Lines ({expense.lines.length}) </Col>
          <Col className="d-flex justify-content-end gap-2">
            <Button size="sm" onClick={handleNewLine} variant="secondary">
              <IconWrapper icon={FaPlus} /> Add line
            </Button>
          </Col>
        </CardHeader>
        <Card.Body>
          <Table striped hover bordered size="sm" className="text-center">
            <thead className="align-middle">
              <tr>
                <th className={styles.wsmall}>Date</th>
                <th className={styles.wlarge}>Starting address</th>
                <th className={styles.wlarge}>Arrival address</th>
                <th className={styles.wlarge}>Description</th>
                <th className={styles.wsmall}>Distance</th>
                <th className={styles.wsmall}>Actions</th>
              </tr>
            </thead>
            <tbody className="align-middle">
              {expense.lines.length === 0 && (
                <tr>
                  <td colSpan={6}>No lines</td>
                </tr>
              )}
              {expense.lines.length > 0 &&
                expense.lines
                  .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
                  .map((line) => (
                    <tr key={line._id}>
                      <td>{moment(line.date).format('DD/MM/YYYY')}</td>
                      <td>{line.origin}</td>
                      <td>{line.destination}</td>
                      <td>{line.description}</td>
                      <td>{line.distance} km</td>
                      <td>
                        <ButtonGroup aria-label="Actions">
                          <Button
                            size="sm"
                            variant="warning"
                            title="Edit"
                            onClick={handleEditLine(line)}
                          >
                            <IconWrapper icon={FaRegPenToSquare} />
                          </Button>
                          <Button
                            size="sm"
                            variant="danger"
                            title="Delete"
                            onClick={handleDelete(line._id)}
                          >
                            <IconWrapper icon={FaRegTrashCan} />
                          </Button>
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
      <LineModal
        id={expense._id}
        expenseType={expense.type}
        line={modalLine}
        show={showAddLine}
        onClose={handleCloseAddLine}
      />
    </>
  );
};

export default Lines;
